import paczkomatyTargetPointInpostGeowidgetHtml from './paczkomatyTargetPointInpostGeowidget.html';
import paczkomatyTargetPointInpostGeowidgetModalHtml from './paczkomatyTargetPointInpostGeowidgetModal.html';

class PaczkomatyTargetPointInpostGeowidgetController {
    constructor($scope, $http, ModalService) {
        'ngInject';

        this.$scope = $scope;
        this.$http = $http;
        this.ModalService = ModalService;

        this.targetPoint = null;
        this.currentTargetPoint = null;
        this.inpostGeowidgetModal = null;
    }

    $onInit() {
        if (this.currentTargetPoint) {
            this.targetPoint = JSON.parse(this.currentTargetPoint);
        }
    }

    initInpostGeowidget() {
        let _this = this;

        if(!_this.inpostGeowidgetModal) {
            _this.ModalService.showModal({
                template: paczkomatyTargetPointInpostGeowidgetModalHtml,
                controller: class {
                    constructor($scope, close) {
                        'ngInject';

                        this.token = null;
                        this.tokens = {
                            production: 'eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJzQlpXVzFNZzVlQnpDYU1XU3JvTlBjRWFveFpXcW9Ua2FuZVB3X291LWxvIn0.eyJleHAiOjIwNDA2MjIzNDIsImlhdCI6MTcyNTI2MjM0MiwianRpIjoiZTM3ZDU5OWEtYTkwMS00NDI5LWExZmUtNzdiNzI5OTc5OTFjIiwiaXNzIjoiaHR0cHM6Ly9sb2dpbi5pbnBvc3QucGwvYXV0aC9yZWFsbXMvZXh0ZXJuYWwiLCJzdWIiOiJmOjEyNDc1MDUxLTFjMDMtNGU1OS1iYTBjLTJiNDU2OTVlZjUzNTpxckxmSDAwRDZWYkp6OUNPTTUwcWRrd3Q1cWd5VC1zY2JwNUdRTk5oYm13IiwidHlwIjoiQmVhcmVyIiwiYXpwIjoic2hpcHgiLCJzZXNzaW9uX3N0YXRlIjoiNzJiYzYxZWMtNzFjNS00MDk5LTgzNzUtMDdhMzEyYWQ5NWM2Iiwic2NvcGUiOiJvcGVuaWQgYXBpOmFwaXBvaW50cyIsInNpZCI6IjcyYmM2MWVjLTcxYzUtNDA5OS04Mzc1LTA3YTMxMmFkOTVjNiIsImFsbG93ZWRfcmVmZXJyZXJzIjoiKi5wbGFzdGljZXhwcmVzcy5wbCxwbGFzdGljZXhwcmVzcy5wbCIsInV1aWQiOiIyMzAxMmY5OS01NGViLTQ3ODQtOTBiMi0wMmQ0ZGZiZWYxNWQifQ.XcOjZ0_TzqNQrhd23FrRU8yS7nfw0CqwhRLGH9zYSNkGXWK47XKvN1eT8fFfztn86kptSwhceaMQkSPy0zy3D9yx8cCuA2K4qTQaaE3-mV2RkyebWtwniicBLRDI0_cn_57v6VMXbXMMXX34T9AN24ENh0LVsK1FqZwR2c4mxRJ8p7NliazUsEuAKsGwHdctm15fwG9RCvnEONgJHbNysjphNGxY73BMbvTMKgAQ89p7YcgKYBXqcQJBNHi4Ri5uTp3Jl6TsqG-tfXF3-ijdsjIVVRKZM0ZCzqlwBQwLwgrH5dnq1qH8JhBjljMKv_0_CX9GVoeY1MBn09SiE4iNQw',
                            sandbox: 'eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJkVzROZW9TeXk0OHpCOHg4emdZX2t5dFNiWHY3blZ0eFVGVFpzWV9TUFA4In0.eyJleHAiOjIwMzk1MjQ2NjYsImlhdCI6MTcyNDE2NDY2NiwianRpIjoiNGE1ZDZjYWQtZDhhMi00MWUzLThlY2YtZGU1MTdjMDU2MzE4IiwiaXNzIjoiaHR0cHM6Ly9zYW5kYm94LWxvZ2luLmlucG9zdC5wbC9hdXRoL3JlYWxtcy9leHRlcm5hbCIsInN1YiI6ImY6N2ZiZjQxYmEtYTEzZC00MGQzLTk1ZjYtOThhMmIxYmFlNjdiOjJtdF8yM25xa0pvb3JqRDBvT296ZXE0MHpKX3dlNEJGVXBlcFhGWFVfaEkiLCJ0eXAiOiJCZWFyZXIiLCJhenAiOiJzaGlweCIsInNlc3Npb25fc3RhdGUiOiI4ZGJkZjMxMC1mMTY2LTQ1ODMtYjg1Yi03NWEwMjM1MzUyYTIiLCJzY29wZSI6Im9wZW5pZCBhcGk6YXBpcG9pbnRzIiwic2lkIjoiOGRiZGYzMTAtZjE2Ni00NTgzLWI4NWItNzVhMDIzNTM1MmEyIiwiYWxsb3dlZF9yZWZlcnJlcnMiOiIqLmNvbnRyYS5tYXEucGwsY29udHJhLm1hcS5wbCIsInV1aWQiOiI4ZTM3NzNkMy00NDhlLTQxMmMtODJiMS0zODI1ZjI1ZmNhY2IifQ.gpVoWI2P58HTBkp9SWKzbAaxa5QKqpFCocjLBkkG8IAJvHr_oHObQcZOCnOe4SEn9IXvNUim76BidJ13CRKb7PY5ee_OoPzYXwGlpqYiC92yOW0tPoDIMLJ2K7h_AD7KI7vKJkN2caV9iXUDmlghUAjOzrOuEcPpKdf_vOL8AwJgf1BvhHvciMi5j8OTFyYtMJitUSUIp-AMoFF3d_OFAGBq7rwbpnHjpKFnYX4E0_ROBezxGldfzvSyv1l9R9IwlnJoo6WoHrGx2jir7y6jk2c99QwGGd2XpIwHp0LSYAAFevGSlgnp4TGsB8FFXHxybTyBYIF448s4MWbe0w8sLg'
                        };
                        this.closeCallback = close;
                        this.init();
                    }

                    init() {
                        if (_this.isDev === 'false') {
                            this.token = this.tokens.production;

                            const geoScript = document.createElement('script');
                            geoScript.type = 'text/javascript';
                            geoScript.src = 'https://geowidget.inpost.pl/inpost-geowidget.js';
                            document.getElementsByTagName('head')[0].appendChild(geoScript);
    
                            const geoCss = document.createElement('link');
                            geoScript.rel = 'stylesheet';
                            geoScript.href = 'https://geowidget.inpost.pl/inpost-geowidget.css';
                            document.getElementsByTagName('head')[0].appendChild(geoCss);
                        } else {
                            this.token = this.tokens.sandbox;

                            const geoScript = document.createElement('script');
                            geoScript.type = 'text/javascript';
                            geoScript.src = 'https://sandbox-easy-geowidget-sdk.easypack24.net/inpost-geowidget.js';
                            document.getElementsByTagName('head')[0].appendChild(geoScript);
    
                            const geoCss = document.createElement('link');
                            geoScript.rel = 'stylesheet';
                            geoScript.href = 'https://sandbox-easy-geowidget-sdk.easypack24.net/inpost-geowidget.css';
                            document.getElementsByTagName('head')[0].appendChild(geoCss);
                        }

                        document.addEventListener('onOrderViewPaczkomatyTargetPointSelect', (event) => {
                            _this.setPaczkomatyTargetPoint(event.detail);
                            _this.inpostGeowidgetModal.element.hide();
                            _this.$scope.$apply();
                        });
                    }

                    cancel() {
                        _this.inpostGeowidgetModal.element.hide();
                    }
                },
                controllerAs: '$ctrl'
            }).then(modal => {
                _this.inpostGeowidgetModal = modal;
            });
        } else {
            _this.inpostGeowidgetModal.element.show();
        }
    }

    setPaczkomatyTargetPoint(point) {
        this.targetPoint = point;

        const setPaczkomatyTargetPoint = new CustomEvent('setPaczkomatyTargetPoint', {detail: this.targetPoint});
        window.dispatchEvent(setPaczkomatyTargetPoint);
    }
}

let paczkomatyTargetPointInpostGeowidgetComponent = {
    bindings: {
        'currentTargetPoint': '@?',
        'isDev': '@'
    },
    template: paczkomatyTargetPointInpostGeowidgetHtml,
    controller: PaczkomatyTargetPointInpostGeowidgetController
};

export default paczkomatyTargetPointInpostGeowidgetComponent;
